import React, { useState, useRef, useEffect } from "react";
import { useUserProfile } from "../../service/hooks";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import {
  Container,
  Button,
  Navbar,
  Image,
  Badge,
  Nav,
  Dropdown,
  Spinner,
} from "react-bootstrap";

import { useHistory, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faSignOutAlt,
  faMagicWandSparkles,
  faEnvelope,
  faPerson,
  faShieldAlt,
  faUserEdit,
  faLink,
  faCompassDrafting,
  faMusic,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";

import Logo from "../../beatai-logo.svg";
import {
  changeAvatar,
  resendVerification,
} from "../../service/api";

import Avatar, { useAvatar } from "../auth/Avatar";

function BeatsHeader() {
  const history = useHistory();
  const verified = localStorage.getItem("verified");
  const [resendingMail, setResendingMail] = useState(false);
  const { firstname, lastname } = useUserProfile();
  
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

  const { getAvatarB64 } = useAvatar();
  const [avatarB64Local, setAvatarB64Local] = useState(null);
  const [changingAvatar, setChangingAvatar] = useState(false);

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];

    // Validate file type (JPEG/PNG)
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG formats are allowed.");
      return;
    }

    try {
      setChangingAvatar(true);
      await changeAvatar(file);
      alert("Avatar updated successfully!");

      // Fetch and update the base64 image in the hook state
      const avatar = await getAvatarB64(true);
      setAvatarB64Local(avatar);
      setChangingAvatar(false);
    } catch (error) {
      alert(error.message);
      setChangingAvatar(false);
    }
  };
  
  useEffect(() => {
    setChangingAvatar(true);

    getAvatarB64()
      .then((avatar) => {
        setChangingAvatar(false);
        setAvatarB64Local(avatar);
      })
      .catch(() => {
        setChangingAvatar(false);
      });
  }, []);

  const uploadAvatarRef = useRef(null);

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="sm" className="w-100 m-0 nav_">
        <Container fluid className="">
          <input
            hidden
            ref={uploadAvatarRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange}
          />
          <Button
            disabled
            variant="outline-light"
            className="border-0"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Navbar.Brand
            className=""
            style={{ cursor: "pointer" }}
            title="+ Start new chat"
            onClick={() => history.push("/chat/")}
          >
            <Image src={Logo} style={{ maxWidth: "100px" }} />
          </Navbar.Brand>
          <Nav className="" style={{ width: "80%" }}>
            <Nav.Link
              as={Link}
              to="/chat"
              className={
                window.location.href.indexOf("chat") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              Chat
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/ai-images/"
              className={
                window.location.href.indexOf("ai-image") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMagicWandSparkles} /> AI Images
            </Nav.Link>
            <Nav.Link
              as={Link}
              title="Coming Soon!"
              to="/ai-workflows/"
              className={
                window.location.href.indexOf("ai-workflows") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faCompassDrafting} /> Workflows
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/chats/"
              title="Coming Soon!"
              disabled
              className={
                window.location.href.indexOf("beats") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMusic} /> Beats
            </Nav.Link>
          </Nav>
          <Dropdown align="end" className="user-avatar-dropdown">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div className="user-avatar" style={{ textAlign: "center" }}>
                {!avatarB64Local &&
                  !changingAvatar &&
                  (firstname ? (
                    firstname[0]
                  ) : (
                    <FontAwesomeIcon icon={faPerson} />
                  ))}
                {!changingAvatar && avatarB64Local && (
                  <Avatar
                    base64Image={avatarB64Local}
                    width="30px"
                    height="30px"
                  />
                )}
                {changingAvatar && <Spinner size="sm" />}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Container fluid>
                <Container className="text-center">
                  <div
                    className="user-avatar"
                    style={{ margin: "0 auto", width: "80px", height: "80px" }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70px"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      fontSize: "var(--font-sm)",
                      color: "white",
                      margin: "0 auto",
                    }}
                  >
                    {firstname} {lastname}
                  </p>
                </Container>
              </Container>
              <Dropdown.Divider />
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  if (uploadAvatarRef.current) {
                    uploadAvatarRef.current.click();
                  }
                }}
              >
                <FontAwesomeIcon icon={faUserEdit} className="me-2" /> Change
                Avatar
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/membership"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faIdBadge} className="me-2" />{" "}
                  Membership
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm">
                <Link
                  to="/account-settings"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />{" "}
                  Account Settings
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  window.open("https://beatbind.io/privacy", "_blank");
                }}
              >
                <FontAwesomeIcon className="me-2" icon={faLink} />
                <a
                  style={{
                    color: "white",
                  }}
                  href="https://beatbind.io/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {verified === "false" ? (
            <i className="ms-auto">
              <Badge>Unverified</Badge>
            </i>
          ) : null}
        </Container>
      </Navbar>
      <Container>
        {resendingMail && (
          <>
            <Spinner size="sm" /> Resending mail
          </>
        )}
        {!resendingMail && verified === "false" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setResendingMail(true);
              resendVerification()
                .then(() => {
                  setResendingMail(false);
                  alert("Link sent!");
                })
                .catch(() => {
                  setResendingMail(false);
                  alert("Couldn't send, please try again later!");
                });
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} />{" "}
            <u>Resend Verification Link</u>
          </span>
        )}
        <br />
      </Container>
      <ToastContainer />
    </>
  );
}

export default BeatsHeader; 